import { SlashCommand } from './types';

export const scenereaderCommands: SlashCommand[] = [
    {
        id: 'sr-removebg',
        trigger: '/removebg',
        name: 'Remove Background',
        description: 'Remove the background from an uploaded image',
        category: 'MEDIA',
        icon: 'fas fa-eraser',
        mode: 'prompt',
        integration: 'SceneReader'
    },
    {
        id: 'sr-detect',
        trigger: '/detect',
        name: 'Detect Objects',
        description: 'Detect objects and bounding boxes in an image',
        category: 'MEDIA',
        icon: 'fas fa-search-plus',
        mode: 'prompt',
        integration: 'SceneReader'
    },
    {
        id: 'sr-analyze',
        trigger: '/analyze',
        name: 'Analyze Scene',
        description: 'Get deep semantic analysis and tags for an image',
        category: 'MEDIA',
        icon: 'fas fa-eye',
        mode: 'prompt',
        integration: 'SceneReader'
    }
];
